import { Component, ContentChildren, QueryList, AfterContentInit} from '@angular/core';
import { CustomSubTabComponent } from './custom-subtab/custom-tab.component';
import { CustomTabComponent } from './custom-tab/custom-tab.component';

@Component({
  templateUrl: 'custom-tabs.html',
  selector: 'custom-tabs'
})

export class CustomTabsComponent implements AfterContentInit {
  @ContentChildren(CustomTabComponent) tabs: QueryList<CustomTabComponent>;
  @ContentChildren(CustomSubTabComponent) subtabs: QueryList<CustomSubTabComponent>;

  public selectTab(tab: CustomTabComponent): void {
    this.tabs.forEach(item => {
      item.active = false
      item.subtabs.forEach((i, index) => index === 0 ? i.active = true : i.active = false)
    });

    tab.active = true;
  }

  public clearTabs() {
    if (this.tabs) this.selectTab(this.tabs.first);
  }

  ngAfterContentInit() {
    const activeTabs = this.tabs.filter((tab) => tab.active);

    if (activeTabs.length === 0) {
      this.selectTab(this.tabs[0]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/custom-tabs/custom-tabs.component.ts